import { Component, inject } from '@angular/core';

import { ThemeService } from '../../../core/services/theme.service';
import { TranslatePipe } from '../../../core/pipes/translate.pipe';

@Component({
  selector: 'demo-theme-toggle',
  standalone: true,
  imports: [TranslatePipe],
  template: `
    <button
      type="button"
      class="demo-theme-toggle"
      (click)="theme.toggle()"
      [attr.aria-pressed]="theme.theme() === 'dark'"
    >
      {{ theme.theme() === 'dark' ? ('theme.light' | demoTranslate) : ('theme.dark' | demoTranslate) }}
    </button>
  `,
  styles: [
    `
      .demo-theme-toggle {
        background: transparent;
        border: 1px solid var(--demo-line);
        border-radius: var(--demo-radius-sm);
        color: var(--demo-ink);
        padding: 0.5em 0.9em;
        font-size: 0.85rem;
        cursor: pointer;
      }
      .demo-theme-toggle:hover {
        background: var(--demo-sand);
      }
    `,
  ],
})
export class ThemeToggleComponent {
  protected readonly theme = inject(ThemeService);
}
